import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index.vue'
import TemplateRoute from './template/route'
import FieldRoute from './templateField/route'
import InviteRecordRoute from './inviteRecord/route'

const basePath = '/v-admin/offer-letter-management'

const routes = [
  InviteRecordRoute,
  TemplateRoute,
  FieldRoute
]

export default {
  name: 'offerLetterInviteRecordManagement',
  path: `${basePath}`,
  redirect: `${basePath}/index`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: {
      strict: false,
      any: [
        'PERM_OFFER_INITIATE',
        'PERM_OFFER_CUSTOM_FIELD_MANAGEMENT',
        'PERM_OFFER_TEMPLATE_MANAGEMENT'
      ],
      every: 'PREMIUM_OFFER_MANAGEMENT'
    },
    titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.offerLetterInviteRecordManagement.title.offerLetterManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/index`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterManagement'
      },
      children: routes
    }
  ]
}
